export class BeatClock {
  private bpm: number;
  private nextBeatTime = 0;
  private beatListeners: Set<(beatCount: number) => void> = new Set();
  private beatCount = 0;
  private running = false;

  constructor(bpm: number = 120) {
    this.bpm = bpm;
  }

  setBpm(bpm: number): void {
    this.bpm = Math.max(20, bpm);
  }

  getBpm(): number {
    return this.bpm;
  }

  getIntervalMs(): number {
    return 60000 / this.bpm;
  }

  start(now: number): void {
    this.running = true;
    this.beatCount = 0;
    this.nextBeatTime = now + this.getIntervalMs();
  }

  pause(): void {
    this.running = false;
  }

  resume(now: number): void {
    if (this.running) return;
    this.running = true;
    this.nextBeatTime = now + this.getIntervalMs();
  }

  reset(now: number): void {
    this.beatCount = 0;
    this.running = true;
    this.nextBeatTime = now + this.getIntervalMs();
  }

  update(now: number): void {
    if (!this.running) return;
    let fired = false;
    let safety = 8;
    while (now >= this.nextBeatTime && safety > 0) {
      this.beatCount++;
      this.nextBeatTime += this.getIntervalMs();
      fired = true;
      safety--;
      for (const fn of this.beatListeners) fn(this.beatCount);
    }
    void fired;
  }

  onBeat(fn: (beatCount: number) => void): () => void {
    this.beatListeners.add(fn);
    return () => {
      this.beatListeners.delete(fn);
    };
  }

  isRunning(): boolean {
    return this.running;
  }
}
